import type { ReactNode } from 'react';

export function PageShell({ title, subtitle, children }: Readonly<{ title: string; subtitle?: string; children: ReactNode }>) {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-(--color-text-primary)">{title}</h1>
        {subtitle && <p className="text-(--color-text-secondary) mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
